import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Evaluation/CriteriaSurveys/Domain/queries';
import { Component } from 'vue-facing-decorator';

@Component
export default class CriteriaSurveysQueries extends VueCqrs
{

	runVotesExportByEvalModelIdQueryV1(workspaceId: number, evalModelId: number)
	{
		const query = q.buildVotesExportByEvalModelIdQueryV1(workspaceId, evalModelId);
		this.$query(query);
	}

	runCriteriaPanelistsPageQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		const query = q.buildCriteriaPanelistsPageQueryV1(workspaceId, projectId, evalModelId, surveyId);
		this.$query(query);
	}


	runCriteriaSurveyPanelistsQueryV1(workspaceId: number, surveyId: number)
	{
		const query = q.buildCriteriaSurveyPanelistsQueryV1(workspaceId, surveyId);
		this.$query(query);
	}

	runCriteriaPanelistsManagerQueryV1(workspaceId: number, surveyId: number)
	{
		const query = q.buildCriteriaPanelistsManagerQueryV1(workspaceId, surveyId);
		this.$query(query);
	}

	runCriteriaPanelistQueryV1(workspaceId: number, surveyId: number, projectUserId: number)
	{
		const query = q.buildCriteriaPanelistQueryV1(workspaceId, surveyId, projectUserId);
		this.$query(query);
	}

	runCriteriaAccessLinksBySurveyIdQueryV1(workspaceId: number, surveyId: number)
	{
		const query = q.buildCriteriaAccessLinksBySurveyIdQueryV1(workspaceId, surveyId);
		this.$query(query);
	}

	runExportAccessLinksBySurveyIdQueryV1(workspaceId: number, surveyId: number)
	{
		const query = q.buildExportAccessLinksBySurveyIdQueryV1(workspaceId, surveyId);
		this.$query(query);
	}

	runCriteriaSurveyQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		const query = q.buildCriteriaSurveyQueryV1(workspaceId, projectId, evalModelId, surveyId);
		this.$query(query);
	}

	runSubSurveysManagerQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		const query = q.buildSubSurveysManagerQueryV1(workspaceId, projectId, evalModelId, surveyId);
		this.$query(query);
	}

	runMeetingManagerPageQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		const query = q.buildMeetingManagerPageQueryV1(workspaceId, projectId, evalModelId, surveyId);
		this.$query(query);
	}

	runMeetingQuestionReviewQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number, questionId: string)
	{
		const query = q.buildMeetingQuestionReviewQueryV1(workspaceId, projectId, evalModelId, surveyId, questionId);
		this.$query(query);
	}


	runPanelistSurveyDashboardPageQueryV1(workspaceId: number, surveyId: number, projectUserId: number)
	{
		const query = q.buildPanelistSurveyDashboardPageQueryV1(workspaceId, surveyId, projectUserId);
		this.$query(query);
	}

	runPanelistMeetingPageQueryV1(workspaceId: number, surveyId: number, projectUserId: number)
	{
		const query = q.buildPanelistMeetingPageQueryV1(workspaceId, surveyId, projectUserId);
		this.$query(query);
	}

	runPanelistSurveyCriterionPageQueryV1(workspaceId: number, surveyId: number, projectUserId: number, criterionId: number)
	{
		const query = q.buildPanelistSurveyCriterionPageQueryV1(workspaceId, surveyId, projectUserId, criterionId);
		this.$query(query);
	}

	runPanelistSurveyCriterionConsistencyAnalysisQueryV1(workspaceId: number, criteriaHierarchyId: number, evalModelId: number, surveyId: number, projectUserId: number, criterionId: number)
	{
		const query = q.buildPanelistSurveyCriterionConsistencyAnalysisQueryV1(workspaceId, criteriaHierarchyId, evalModelId, surveyId, projectUserId, criterionId);
		this.$query(query);
	}


	runProjectUserVoteQueryV1(workspaceId: number, projectUserId: number, questionId: string)
	{
		const query = q.buildProjectUserVoteQueryV1(workspaceId, projectUserId, questionId);
		this.$query(query);
	}

	runPanelDisagreementsQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		const query = q.buildPanelDisagreementsQueryV1(workspaceId, projectId, evalModelId, surveyId);
		this.$query(query);
	}

	runPanelConsistencyAnalysisQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		const query = q.buildPanelConsistencyAnalysisQueryV1(workspaceId, projectId, evalModelId, surveyId);
		this.$query(query);
	}

	runPanelistConsistencyAnalysisQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number, projectUserId: number)
	{
		const query = q.buildPanelistConsistencyAnalysisQueryV1(workspaceId, projectId, evalModelId, surveyId, projectUserId);
		this.$query(query);
	}

}